/*
 * ADA compliance by 216 digital
 */
function keyToClick(event) {
  if (event.key == 'Enter') {
    event.preventDefault()
    event.target.click()
  }
}

// Mega-nav follows the WAI-ARIA APG disclosure navigation pattern: focus alone never opens a
// panel, the top-level button toggles it. Hover open/close stays in scripts/sections/header.js.
const megaNavs = Array.from(
  document.querySelectorAll('[id="meganav-heading"]')
).map((button) => ({
  button,
  dropdown: document.querySelector(
    `[meganav_index="${button.getAttribute('meganav_heading_index')}"]`
  ),
  wrapper: button.closest('.mega-menu'),
}))

function isDropdownOpen(dropdown) {
  return dropdown.style.display === 'block'
}

function setDropdownOpen({ button, dropdown }, open) {
  button.classList.toggle('active', open)
  dropdown.classList.toggle('active', open)
  button.setAttribute('aria-expanded', open ? 'true' : 'false')
  dropdown.style.display = open ? 'block' : 'none'
}

megaNavs.forEach((megaNav) => {
  const { button, dropdown, wrapper } = megaNav
  if (!dropdown || !wrapper) return

  // header.js shows and hides panels on hover through inline display; keep aria-expanded in step
  new MutationObserver(() => {
    button.setAttribute(
      'aria-expanded',
      isDropdownOpen(dropdown) ? 'true' : 'false'
    )
  }).observe(dropdown, { attributes: true, attributeFilter: ['style'] })

  button.addEventListener('click', function (e) {
    // Enter / Space fire click with detail 0 and toggle. A pointer click only opens, so it
    // can't close a panel the user just opened by hovering.
    const open = e.detail === 0 ? !isDropdownOpen(dropdown) : true

    if (open) {
      megaNavs.forEach((other) => {
        if (
          other !== megaNav &&
          other.dropdown &&
          isDropdownOpen(other.dropdown)
        ) {
          setDropdownOpen(other, false)
        }
      })
    }

    setDropdownOpen(megaNav, open)
  })

  wrapper.addEventListener('focusout', function (e) {
    if (wrapper.contains(e.relatedTarget)) return
    // A click on non-focusable panel content drops focus to <body>; hover owns the panel then
    if (!e.relatedTarget && wrapper.matches(':hover')) return
    if (isDropdownOpen(dropdown)) setDropdownOpen(megaNav, false)
  })

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isDropdownOpen(dropdown)) return

    const focusInPanel = dropdown.contains(document.activeElement)
    setDropdownOpen(megaNav, false)
    document.querySelectorAll('.main-menu-item').forEach((item) => {
      item.style.opacity = ''
    })

    if (focusInPanel) button.focus()
  })
})

setTimeout(() => {
  let rebuyImage = document.querySelectorAll('.rebuy-cart__empty-cart-image')
  if (rebuyImage) {
    for (let i = 0; i < rebuyImage.length; i++) {
      rebuyImage[i].setAttribute('alt', 'Rebuy Cart Presentational Image')
    }
  }
}, 1250)
